var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d-flex text-uppercase justify-content-center",attrs:{"href":"/api/rest/profile/diary/download"}},[_vm._v(_vm._s(_vm.trans("courses.certificate.download")))])}
var staticRenderFns = []

export { render, staticRenderFns }